import {
  DataTablePrimeReact,
  IColumnProps,
  PaginationERP,
  TableERP,
} from "@finanedi.es/storybook"
import { RemesaReadingFilteredDtoProps } from "api/DTOs/RemesaReadingFilteredDto"
import { AntdPaginationProps } from "api/interfaces/AntdPagination"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import { Dispatch, RefObject, SetStateAction } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"

export interface TableRemesasProps {
  columns: IColumnProps[]
  dtRef: RefObject<DataTablePrimeReact<RemesaReadingFilteredDtoProps[]>>
  items: Array<RemesaReadingFilteredDtoProps>
  loading: boolean
  totalCount: number
  pagination: { itemsPerPage: number; skipCount: number }
  setPagination: Dispatch<SetStateAction<AntdPaginationProps>>
  sortField: string | undefined
  sortOrder: 1 | 0 | -1 | null | undefined
  selection: RemesaReadingFilteredDtoProps[]
  setSelection: Dispatch<SetStateAction<RemesaReadingFilteredDtoProps[]>>
  onSort: (e: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => void
}

export const TableRemesas: React.FC<TableRemesasProps> = ({
  columns,
  dtRef,
  items,
  loading,
  totalCount,
  pagination,
  setPagination,
  sortField,
  sortOrder,
  selection,
  setSelection,
  onSort,
}: TableRemesasProps) => {
  const history = useHistory()
  const { t } = useTranslation()

  const onRowClick = async ({
    data,
  }: {
    data: RemesaReadingFilteredDtoProps
  }) => {
    if (!data.id) return
    history.push(`${ROUTES.REMESAS}/${data.id}`)
  }

  return (
    <div className='tw-flex tw-flex-col tw-flex-1 tw-relative tw-h-full'>
      <div className='tw-h-[calc(100%-60px)]'>
        <TableERP
          data-testid='tabla-remesas'
          id='tabla-remesas'
          refTable={dtRef}
          columns={columns}
          className='tw-h-full !tw-z-0'
          columnResizeMode='expand'
          sortField={sortField}
          sortOrder={sortOrder}
          onSort={onSort}
          removableSort
          value={items}
          showGridlines
          lazy
          dataKey='id'
          scrollable
          selection={selection}
          selectionMode='checkbox'
          size='small'
          selectionColumnMode='multiple'
          onRowClick={onRowClick}
          onSelectionChange={({
            value,
          }: {
            originalEvent: React.SyntheticEvent
            value: RemesaReadingFilteredDtoProps[]
            type?: "multiple" | "all" | "checkbox" | "row" | undefined
          }) => {
            setSelection(value)
          }}
          loading={loading}
          emptyMessage={t("primeReact.table.emptyMessage")}
        />
      </div>
      <PaginationERP
        className={PAGINATION_STYLES}
        totalRecords={totalCount}
        first={pagination.skipCount}
        rows={pagination.itemsPerPage}
        resetScroll={() => dtRef.current && dtRef.current?.resetScroll()}
        setPagination={setPagination}
        optionDropdown={[10, 20, 50, 100]}
        texts={{
          textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
          textCurrentPageReport: `${t("pagination.from")}`,
        }}
      />
    </div>
  )
}
